import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";
import ImageUploader from "../../components/upload-image";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, id } = useAddWorkProvider();

  return (
    <Section className="h-[80vh] px-5 overflow-y-auto mt-5">
      <Label label={id ? "Updated Testimonial Details" : "Add Testimonial Details"} className="text-[18px] text-black" />
      <Formik initialValues={initialValues} enableReinitialize={true} onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
              <div className="flex flex-col">
                <Label label="Name" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="name" rootClassName="w-full" />
              </div>
              <div className="flex flex-col">
                <Label label="Position" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="position" rootClassName="w-full" />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3 mt-2 ">
              <div className="flex flex-col">
                <Label label="Rating" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="rating" type="number" rootClassName="w-full" />
              </div>
              <div className="flex flex-col">
                <Label label="User Image Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="alt_tag" rootClassName="w-full" />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3 mt-3">
              <div className="flex flex-col col-span-3">
                <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikTextarea name="description" rootClassName="w-full" />
              </div>
            </div>
            <Label label="User Image" className="mt-3 text-black text-[15px]" />
            <div className="w-full  mb-5 ">
              <ImageUploader
                imageUrl={values?.user_image}
                onChange={(res) => {
                  setFieldValue(`user_image`, res?.data?.file_url);
                }}
              />
            </div>
            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
